import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CorseLuceService {

  constructor(protected http: HttpClient) { }

  list(): Observable<string[]> {
    return this.http.get<any>('/corse-luce')
      .pipe(
        map(items => items.map(i => i.code))
      );
  }

  add(code: string): Observable<string> {
    return this.http.post<any>('/corse-luce', {code})
      .pipe(
        map(data => data.code)
      );
  }

  remove(code: string): Observable<string> {
    return this.http.delete<any>(`/corse-luce/${code}`)
    .pipe(
      map(data => data.code)
    );
  }
}
